module.exports = __webpack_public_path__ + "static/img/jprm-2.ca7f0097.jpg";